import { connect } from 'react-redux';
import { getShopState } from 'services/shopify/selectors';
import ShopifyOverlayEditor from './ShopifyOverlayEditor';

const mapStateToProps = state => ({
  shopInfo: getShopState(state),
});

export default connect(mapStateToProps)(ShopifyOverlayEditor);
